export const DAILY_RENT_OTA_CONVERSION = 'dailyrent_web_sut375_online_booking_cr';

export const NEWBUILDING_MONTHLY_PAYMENT = 'newbuilding_monthly_payment_desktop';

export const BX_COMISSION_FILTER_EXPERIMENT = 'vx_desktop_bx_785_filters_comission';

export const EXPERIMENTS = [DAILY_RENT_OTA_CONVERSION, NEWBUILDING_MONTHLY_PAYMENT, BX_COMISSION_FILTER_EXPERIMENT];
